/**
 * Token de Entra ID para la capa de DATOS (PostgREST sobre Azure PostgreSQL).
 *
 * Cuando `VITE_DATA_AUTH=entra`, el cliente Supabase deja de usar la `anon key`
 * como identidad y pasa el token de Entra ID del usuario como `Authorization:
 * Bearer`. PostgREST lo valida (JWKS de Entra) y expone sus claims a las
 * políticas RLS — así el aislamiento por tenant/contratista se aplica del lado
 * servidor, no en el cliente.
 *
 * El token se pide con la **audiencia propia de la app** (scope expuesto
 * `api://<client-id>/pmis.access`, ver el pedido a IT). Espeja el patrón de
 * adquisición de `graphClient`/`graphMailer`.
 *
 * Gating: si falta el scope o no hay MSAL/cuenta, devuelve `null` y el cliente
 * cae al modo `anon key` (piloto) sin romperse.
 */

import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { getMsalInstance } from "@core/auth/msalInstance";
import { DEPLOYMENT } from "@core/access/deployment";

const DATA_SCOPE = DEPLOYMENT.dataApiScope;

export async function obtenerTokenDatos(): Promise<string | null> {
  if (!DATA_SCOPE) return null;
  const msal = getMsalInstance();
  if (!msal) return null;
  const account = msal.getActiveAccount() ?? msal.getAllAccounts()[0];
  if (!account) return null;
  try {
    const r = await msal.acquireTokenSilent({ scopes: [DATA_SCOPE], account });
    return r.accessToken;
  } catch (e) {
    if (e instanceof InteractionRequiredAuthError) {
      const r = await msal.acquireTokenPopup({ scopes: [DATA_SCOPE], account });
      return r.accessToken;
    }
    return null;
  }
}
